import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {et} from "../locales/i18n.tsx";
import type {Port} from "./ModelTypes.ts";
import {t} from "i18next";


export class PortForwardingAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);

        this.localization = localization;
    }
}

type Bundle = {
    amount: number,
    creatable: boolean,
    quota: number,
};

export class PortForwardingAPIConnectorExceedingLimitError extends BlueshiftAPIConnectorError {
    public readonly localization: string;
    public readonly bundle: Bundle;

    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, "exceeding_limit");
        this.bundle = err.message as unknown as Bundle;

        this.localization = localization;
    }
}

function convertException(err: object) {
    if (err instanceof BlueshiftAPIConnectorError) {
        if (err.cause === "app.service.network.exception.PortForwardingServiceExceptionCause.exceeding_limit") {

            return new PortForwardingAPIConnectorExceedingLimitError(err, `${t("portForwarding.limitExceededCurrentCount")}: {limitAmountData}, ${t("portForwarding.allowedNumber")}: {limitQuotaData}`);
        }

        return new PortForwardingAPIConnectorError(err, et(err.cause));
    }

    return err;
}

export const network = {

    ports: [],

    /**
     * Compute Port 를 로드
     * 완료후 network.ports 가 갱신되며, 아래 콜백이 호출
     *
     */

    async getPortList() {
        try {
            const port = await restfulApiClient.get('ports', 1);
            if (port) {
                network.ports = port.data.data;
            }
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new PortForwardingAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async deletePort(instance_id: number, protocol: string, internalPort: number, portId: number) {
        try {
            return await restfulApiClient.delete(`server/${instance_id}/ports/${protocol}/${internalPort}?port=${portId}`, 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new PortForwardingAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }

    },

    portForwardRule: {
        /**
         * Returns a random integer between min (inclusive) and max (inclusive).
         * The value is no lower than min (or the next integer greater than min
         * if min isn't an integer) and no greater than max (or the next integer
         * lower than max if max isn't an integer).
         * Using Math.round() will give you a non-uniform distribution!
         */

        async add(instance_id: number, protocol: string, internalPort: number): Promise<Port | undefined> {
            if (internalPort < 1 || internalPort > 65535) {
                throw "포트 번호는 1~65535까지만 가능합니다";
            }

            const payload = {
                "server_id": instance_id,
                "proto": protocol,
                "intern_port": internalPort,
            }

            try {
                const response = await restfulApiClient.put(`server/${instance_id}/ports`, 1, payload);
                if (!response) return undefined;
                const responseData = response.data;
                return responseData.data;
            } catch (err) {
                throw convertException(err as object);
            }
        },

        async getPortListByServerId(instance_id: number) {
            try {
                return await restfulApiClient.get('server/' + instance_id + '/ports', 1)
            } catch (err) {
                if (err instanceof BlueshiftAPIConnectorError) {
                    throw new PortForwardingAPIConnectorError(err, et(err.cause));
                }
                throw err;
            }
        }
    }
}